module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_itr_r1"
    }
  }, [_c('em', [_vm._v("Introduction")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_p01_r1"
    }
  }, [_c('strong', [_vm._v("PART ONE: THE IMPRINT A BODY MAKES")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c01_r1"
    }
  }, [_vm._v("1. Last Hours")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c02_r1"
    }
  }, [_vm._v("2. This Is the News")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c03_r1"
    }
  }, [_vm._v("3. A Baby and a Basketball Game")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A Dog Is Better Than a Pill")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. So Much Potential")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART TWO: NOT AN EMERGENCY")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. What Is a Crisis?")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Possible Paths")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Still Alive")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Mysteries of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Two Visions")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART THREE: HEAL THYSELF")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Doctors’ Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. “Take Five Years”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. A Piece of Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. “"), _c('em', [_vm._v("This")]), _vm._v(" Was Medicine”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. “Maybe I Can Make You Laugh”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Barriers to Change")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_p04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART FOUR: MEDICINE AND LOVE ARE NOT THE SAME THING")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. One Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Families as “Problems”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. No One in Charge")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Economics of Dying")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Most Important Time")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_p05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART FIVE: SMELLING THE ROSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. “Her Wishes Were Totally Ignored”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. The Desire for Control")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Dreams Coming True")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. The Final Caress")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. “We Can Celebrate”")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_p06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART SIX: A GIFT OF SILVER")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Lobster Newburg")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. A Bowl of Applesauce")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Illness As Opportunity")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_p07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART SEVEN: THE LESSON OF THE LEAVES")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. The Endless Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c31_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. An Agenda for Improvement")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_c32_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Four Final Lessons")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sources and Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312374648_epub_ind_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81fb077e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312374648_epub_toc_r1.vue
// module id = 69
// module chunks = 0